module.exports = __webpack_public_path__ + "img/s5Logo.b5d01723.svg";